import React from 'react';
import PropTypes from 'prop-types';

// TODO: When moving between pages, it should automatically scroll to the top
const NextButton = ({ id, title }) => {
  return (
    <button id={id} className="btn accent-teal" type="submit">
      {title}
    </button>
  );
};

NextButton.propTypes = {
  title: PropTypes.string,
};

NextButton.defaultProps = {
  title: 'Next',
};

export default NextButton;
